import ServerApi from './$server.api'

export default {
    createClient,
    createInvoice,
    getClient,
    getInvoices,
    getInvoiceDocument,
    cancelInvoice
}

async function createClient(data) {
    return await ServerApi.request('post', '/invoices/clients', {data})
}

async function createInvoice(data) {
    const timezone = new Date().getTimezoneOffset()/60
    const query = {timezone}
    return await ServerApi.request('post', '/invoices', {data, query})
}

async function getClient() {
    return await ServerApi.request('get', '/invoices/clients')
}

async function getInvoices() {
    return await ServerApi.request('get', '/invoices')
}

async function getInvoiceDocument(invoiceId, type) {
    return await ServerApi.request('get', `/invoices/${invoiceId}/${type}`)
}

async function cancelInvoice(invoiceId) {
    return await ServerApi.request('delete', `/invoice/invoices${invoiceId}/cancel`)
}